import { useLayoutEffect, useRef, useState } from "react";
import { useBranding } from "../../store/branding-context";

const OrganisationBrandLogo = ({
  alt = "organisationLogo",
  className = "h-16 w-auto max-w-[220px] object-contain",
  skeletonClassName = "h-16 w-40 max-w-[220px]",
  testId,
  fallback = null,
}) => {
  const { organisationData, isLoading } = useBranding();
  const logoUrl = organisationData?.organisation_logo || "";
  const imageRef = useRef(null);
  const [imageLoaded, setImageLoaded] = useState(false);
  const [imageFailed, setImageFailed] = useState(false);

  useLayoutEffect(() => {
    const el = imageRef.current;
    setImageLoaded(Boolean(el?.complete && el.naturalWidth > 0));
    setImageFailed(false);
  }, [logoUrl]);

  if (!isLoading && (!logoUrl || imageFailed)) {
    return fallback;
  }

  const showSkeleton = isLoading || (Boolean(logoUrl) && !imageLoaded);

  return (
    <span className="relative inline-flex items-center">
      {showSkeleton && (
        <span
          aria-hidden="true"
          id={testId ? `${testId}-skeleton` : undefined}
          className={`block animate-pulse rounded-lg bg-gray-200 ${skeletonClassName}`}
        />
      )}
      {logoUrl && !imageFailed ? (
        <img
          ref={imageRef}
          src={logoUrl}
          alt={alt}
          id={testId ? `${testId}-image` : undefined}
          className={`${className} transition-opacity duration-300 ease-out ${
            imageLoaded
              ? "opacity-100"
              : "pointer-events-none absolute opacity-0"
          }`}
          onLoad={() => setImageLoaded(true)}
          onError={() => {
            setImageFailed(true);
            setImageLoaded(false);
          }}
        />
      ) : null}
    </span>
  );
};

export default OrganisationBrandLogo;
